var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('SearchableTable',{attrs:{"panel-header":'Darreichungsform (Einheit)',"panel-route":'',"show-search-bar":true,"table-data":_vm.dataObject,"table-meta-data":_vm.tableMetaData,"query-string":'setMedicationUnitSearchQuery',"event-value":_vm.parentEventValue}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }